/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTransfer = createReactComponent("outline", "transfer", "IconTransfer", [["path", { "d": "M20 10h-16l5.5 -6", "key": "svg-0" }], ["path", { "d": "M4 14h16l-5.5 6", "key": "svg-1" }]]);

export { IconTransfer as default };
//# sourceMappingURL=IconTransfer.mjs.map
